<template>
  <div class="messageDetail">
    <img src="../../assets/images/detail/bgg.png" alt="" class="bg_img" />
    <div class="navbar">
      <span>资讯详情</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="message_content">
      <div class="message_title" v-if="detailInfo.name">{{ detailInfo.name }}</div>
      <div class="sub_title d-f jc-sb ai-c" v-if="detailInfo.unitName">
        <span>{{ detailInfo.unitName }}</span>
        <span>{{ detailInfo.showedTime }}</span>
      </div>
      <div class="content" v-html="detail"></div>
    </div>
  </div>
</template>
<script>
import { basicInfoDetails } from '@/api/information.js'
import { format } from '@/utils/DES.js'
export default {
  name: 'messageDetail',
  data() {
    return {
      detailInfo: {},
      detail: '',
    }
  },
  methods: {
    back() {
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    getDetail(id) {
      basicInfoDetails(id).then((res) => {
        this.detailInfo = res.result
        this.detail = format(this.detailInfo.detail)
      })
    },
  },
  mounted() {
    console.log('this.$route====>', JSON.parse(this.$route.query.params))
    const data = JSON.parse(this.$route.query.params)
    this.getDetail(data.id)
  },
}
</script>
<style lang="scss" scoped>
.messageDetail {
  width: 100%;
  height: 100vh;
  // background: #fff;
  background: #fff9f0;
  position: relative;
  .bg_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 24rem;
  }
  .navbar {
    z-index: 9999;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    // background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .message_content {
    padding: 0.2rem 0.6rem 0 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    width: 100%;
    // height: calc(100% - 84px - env(safe-area-inset-top));
    height: calc(100% - 84px);
    position: absolute;
    // top: calc(84px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .message_title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #212121;
    line-height: 1.4rem;
    margin-bottom: 0.4rem;
  }
  .sub_title {
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.8rem;
    padding-bottom: 0.6rem;
    // border-bottom: 1px solid #f4f4f4;
    margin-bottom: 0.6rem;
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    img {
      width: 100%;
      height: 9.7rem;
      margin: 0.8rem 0;
      border-radius: 0.5rem;
    }
  }
}
</style>
